import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

const MOCK_REQUEST_DURATION = 3000; // 3 segundos simulando uma requisição
const DEFAULT_CYCLE_DURATION = 20000; // 20 segundos

interface AutoProgressBarProps {
  onComplete: () => void;
  durationMs?: number;
}

export const AutoProgressBar: React.FC<AutoProgressBarProps> = ({ onComplete, durationMs = DEFAULT_CYCLE_DURATION })=> {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isLoading) return;

    const start = Date.now();

    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - start;
      const percent = Math.min((elapsed / durationMs) * 100, 100);

      if(percent > 5)
        setProgress(percent);

      if (percent >= 100) {
        clearInterval(intervalRef.current!);
        setIsLoading(true);

        Promise.resolve(onComplete()).finally(() => {
          setIsLoading(false);
          setProgress(0);
        });
      }
    }, 100);

    return () => clearInterval(intervalRef.current!);
  }, [isLoading, durationMs]);

  return (
    <Container>
      <Bar
        style={{ width: `${progress}%` }}
        $loading={isLoading}
      />
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 6px;
  width: 100%;
  /* background-color: rgba(0,0,0,0); */
  z-index: 250;
`;

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const Bar = styled.div<{ $loading: boolean }>`
  height: 100%;
  background: -webkit-linear-gradient(45deg, rgb(62, 147, 216), rgb(76, 185, 49));
  transition: width 0.8s cubic-bezier(0.25, 0.1, 0.25, 1);

  ${({ $loading }) =>
    $loading &&
    css`
      animation: ${pulse} 1s infinite;
    `}
`;
